import {
  MENU_INIT,
  STORE_INIT,
  USERS_ADD,
  USERS_DELETE,
  USERS_EDIT,
  USERS_PAGE_CLOSE_MODAL,
  USERS_PAGE_INIT,
  USERS_PAGE_SET_MODAL,
  USERS_X_MENU_ADD,
  USERS_X_MENU_DELETE,
  USERS_X_MENU_INIT,
  USERS_X_STORE_ADD,
  USERS_X_STORE_DELETE,
  USERS_X_STORE_INIT,
  USERS_X_VARIABLES_ADD,
  USERS_X_VARIABLES_DELETE,
  USERS_X_VARIABLES_INIT,
} from "./users-page-actions";
import {
  USERS_PAGE_GLOBAL_VARIABLE_ADD,
  USERS_PAGE_GLOBAL_VARIABLE_DELETE,
  USERS_PAGE_GLOBAL_VARIABLE_EDIT,
  USERS_PAGE_GLOBAL_VARIABLE_INIT,
} from "./users-page-global-variable-actions";
import {
  USERS_PAGE_VARIABLE_ADD,
  USERS_PAGE_VARIABLE_DELETE,
  USERS_PAGE_VARIABLE_EDIT,
  USERS_PAGE_VARIABLE_INIT,
} from "./users-page-variable-actions";

export default function usersPageReducer(state = null, action) {
  switch (action.type) {
    case USERS_PAGE_INIT:
      return {
        ...state,
        users: action.data,
      };
    case USERS_PAGE_SET_MODAL:
      return { ...state, modal: action.data };
    case USERS_PAGE_CLOSE_MODAL:
      return { ...state, modal: null };
    case USERS_ADD:
      return { ...state, users: [...state.users, action.data], modal: null };
    case USERS_EDIT:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.data.id ? action.data : user
        ),
        modal: null,
      };
    case USERS_DELETE:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.data),
        modal: null,
      };
    case USERS_PAGE_VARIABLE_INIT:
      return { ...state, modal: null, variables: action.data };
    case USERS_PAGE_VARIABLE_ADD:
      return {
        ...state,
        modal: null,
        variables: [...state.variables, action.data],
      };
    case USERS_PAGE_VARIABLE_EDIT:
      return {
        ...state,
        modal: null,
        variables: state.variables.map((variable) =>
          variable.id === action.data.id ? action.data : variable
        ),
      };
    case USERS_PAGE_VARIABLE_DELETE:
      return {
        ...state,
        modal: null,
        variables: state.variables.filter(
          (variable) => variable.id !== action.data
        ),
      };
    case USERS_PAGE_GLOBAL_VARIABLE_INIT:
      return { ...state, globalVariables: action.data };
    case USERS_PAGE_GLOBAL_VARIABLE_ADD:
      return {
        ...state,
        modal: null,
        globalVariables: [...state.globalVariables, action.data],
      };
    case USERS_PAGE_GLOBAL_VARIABLE_EDIT:
      return {
        ...state,
        modal: null,
        globalVariables: state.globalVariables.map((variable) =>
          variable.id === action.data.id ? action.data : variable
        ),
      };
    case USERS_PAGE_GLOBAL_VARIABLE_DELETE:
      return {
        ...state,
        modal: null,
        globalVariables: state.globalVariables.filter(
          (variable) => variable.id !== action.data
        ),
      };
    case USERS_X_VARIABLES_INIT:
      return { ...state, usersXVariables: action.data };
    case USERS_X_VARIABLES_ADD:
    case USERS_X_VARIABLES_DELETE:
      return {
        ...state,
        usersXVariables: {
          ...state.usersXVariables,
          ...action.data,
        },
      };
    case MENU_INIT:
      return { ...state, menus: action.data };
    case USERS_X_MENU_INIT:
      return {
        ...state,
        usersXMenu: action.data,
      };
    case USERS_X_MENU_ADD:
    case USERS_X_MENU_DELETE:
      return {
        ...state,
        usersXMenu: {
          ...state.usersXMenu,
          ...action.data,
        },
      };
    case STORE_INIT:
      return { ...state, stores: action.data };
    case USERS_X_STORE_INIT:
      return {
        ...state,
        usersXStore: action.data,
      };
    case USERS_X_STORE_ADD:
    case USERS_X_STORE_DELETE:
      return {
        ...state,
        usersXStore: {
          ...state.usersXStore,
          ...action.data,
        },
      };
    default:
      return state;
  }
}
